export const CH_SERVICE_TYPES = {
    DOORLOCKS: [],
    GARAGEDOORS: [],
    LIGHTS: ["com.clarecontrols.widgets.lighting.dimmer", "com.clarecontrols.widgets.lighting"],
    SECURITY: ["com.clarecontrols.widgets.intrusionPartition"],
};
